module.exports = __webpack_public_path__ + "static/media/safari-icon.18f40448.png";